import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState } from 'react';
var useUpdateEffect = function useUpdateEffect(callback, deps) {
  var callbackRef = useRef(callback);
  callbackRef.current = callback;
  var _useState = useState(function () {
      return {
        current: deps
      };
    }),
    _useState2 = _slicedToArray(_useState, 1),
    cachedDeps = _useState2[0];
  if (deps.length !== cachedDeps.current.length) {
    cachedDeps.current = deps;
    callbackRef.current();
  } else {
    for (var i = 0; i < deps.length; i += 1) {
      if (!Object.is(deps[i], cachedDeps.current[i])) {
        cachedDeps.current = deps;
        callbackRef.current();
        break;
      }
    }
  }
};
export default useUpdateEffect;